export default {
  getInfo: {
    method: 'get',
    url: '/auth/user'
  },
  updateInfo: {
    method: 'put',
    url: '/auth/user'
  },

  findUser: {
    method: 'get',
    url: '/auth/user/find?key=KEY'
  },
  authInviteUser: {
    // api invite user
    method: 'get',
    url: '/auth/invite-user?token=TOKEN'
  }
}
